import React from "react";
import PresenceMap from "@/components/PresenceMap";

// "Serving Worldwide" — the closing footprint section, extracted so About.jsx
// composition-level structure is easier to scan.
export default function AboutPresenceSection() {
  return (
    <section className="md-section md-about-presence" data-testid="about-presence-section">
      <div className="md-about-presence-bg" aria-hidden />
      <div className="md-container">
        <div className="md-about-presence-intro">
          <div className="md-label-eyebrow mb-3">Our footprint</div>
          <h2 className="text-3xl md:text-5xl font-serif" data-testid="about-presence-title">
            Serving <em style={{ color: "var(--md-primary)", fontStyle: "italic" }}>Worldwide</em>
          </h2>
          <p className="text-base mt-3 md-about-presence-sub">
            Our therapy and mentorship services have reached individuals from nine nationalities, while ATLAS Research is connected to professionals and researchers across 12 countries.
          </p>
        </div>
        <PresenceMap />
      </div>
    </section>
  );
}
